import { get } from "@services/apiService.js";

export default {
  getCategories(lang) {
    return get(`/v4/product-manager/v1/categories`, { language : lang })
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getBrands(lang) {
    return get(`/v4/product-manager/v1/brands`, { language : lang })
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProducts(arrFilter) {
    return get(`/v4/product-manager/v1/products`, arrFilter)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getBadges(lang) {
    return get(`/v4/product-manager/v1/badges`, {language : lang})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
}
